module.exports = __webpack_public_path__ + "img/other.67598503.svg";